// Author Liu Cui Cui
// Date 2022-07-21 20:18:25

import * as model from "@/model/sithMes/tpm/SithMesTpmTsdOpcConfigTtcModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesTpmTsdOpcConfigTtc(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_TPM_URL,
    })
    .buildStore()
